export const routes = {
  SIGNUP: "/signup",
  SIGNIN: "/signin",
  VERIFY_EMAIL: "/verify-email",
  FORGOT_PASSWORD: "/forgot-password",
  HOME: "/home",
  SEARCH: "/search",
  ADVISOR_PROFILE: "/advisors-profile",
  ADVISOR_PROFILE_PUBLIC: "/advisors-profile/:id",
  ADVISOR_TOPIC_DETAILS: "/advisors-topic-details",
  ADVISOR_WORD_DETAILS: "/advisors-word-details/:appointmentId",
  BE_AN_ADVISOR: "account/be-an-advisor",
  REACH_US: "account/reach-us",
  SETTINGS: "account/settings",
  CHANGE_PASSWORD: "account/change-password",
  PROFILE_DETAILS: "/profile-details",
  RESCHEDULE: "/reschedule",
  SCHEDULE_DETAILS: "/schedule-details",
  REPORT_ISSUE: "/report-issue",
  HISTORY: "/history",
  NOTFOUND: "*",
  SIGNOUT: "/signup",
  PAYMENT: "/payment",
  ABOUT: "/about",
  HOW_IT_WORKS: "/how-it-works",
  FAQS: "/faqs",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_USE: "/terms-use",
  CANCELLATION_POLICY: "/cancellation-policy",
  INDEX_PATH: "/"
};
